const Yup = require('yup');

const checkoutSchema = (tr, visibleCheckOutFormInputs) => {
	const personSchemaObject = visibleCheckOutFormInputs.filter(i => !i.companyField).concat([{ id: 'otherUniversityName' }, { id: 'otherFaculty' } ]).reduce((schema, input) => {
		const { id, required } = input;
		if (required) {
			schema[id] = Yup.string().required(tr('Required'));
		} else {
			schema[id] = Yup.string();
		}

		if (id === 'phone') {
			schema[id] = schema[id]
				.matches(/^[0-9]+$/, tr('Must be only digits'))
				.min(9, tr('Phone number is not valid'));
		} else if (id === 'email') {
			schema[id] = schema[id].email(tr('Must be an email'));
		} else if (id === 'studyYear') {
			if (required) {
				schema[id] = Yup.number()
					.when('stayPurpose', {
						is: (stayPurpose) => stayPurpose === 'study',
						then: Yup.number()
							.integer(tr('Incorrect format. Allowed symbols: 0-9'))
							.required(tr('Required')),
					});
			} else {
				schema[id] = Yup.number()
					.integer(tr('Incorrect format. Allowed symbols: 0-9'));
			}
		} else if (id === 'preferredCheckInDate') {
			if (required) {
				schema[id] = Yup.date().nullable().typeError('Invalid date').required(tr('Required'));
			} else {
				schema[id] = Yup.date().nullable().typeError('Invalid date');
			}
		} else if (id === 'birthday') {
			if (required) {
				schema[id] = Yup.date().nullable().typeError('Invalid date').required(tr('Required'));
			} else {
				schema[id] = Yup.date().nullable().typeError('Invalid date');
			}
		} else if (id === 'universityName') {
			if (required) {
				schema[id] = Yup.string().nullable()
					.when('stayPurpose', {
						is: (stayPurpose) => stayPurpose === 'study',
						then: Yup.string().required(tr('Required')),
					});
			} else {
				schema[id] = schema[id] = Yup.string().nullable();
			}
		} else if (id === 'otherUniversityName') {
			schema[id] = Yup.string().nullable()
				.when('universityName', {
					is: (universityName) => universityName === 'Other',
					then: Yup.string().required(tr('Required')),
				});
		} else if (id === 'otherFaculty') {
			schema[id] = Yup.string().nullable()
				.when('faculty', {
					is: (faculty) => faculty === 'Other',
					then: Yup.string().required(tr('Required')),
				});
		}  else if (id === 'faculty') {
			if (required) {
				schema[id] = Yup.string().nullable()
					.when('stayPurpose', {
						is: (stayPurpose) => stayPurpose === 'study',
						then: Yup.string().required(tr('Required')),
					});
			} else {
				schema[id] = schema[id] = Yup.string().nullable();
			}
		} else if (id === 'typeOfStudent') {
			if (required) {
				schema[id] = Yup.string().nullable()
					.when('stayPurpose', {
						is: (stayPurpose) => stayPurpose === 'study',
						then: Yup.string().required(tr('Required')),
					});
			} else {
				schema[id] = schema[id] = Yup.string().nullable();
			}
		}

		return schema;
	}, {});

	const companySchemaObject = visibleCheckOutFormInputs.filter(i => i.companyField === true).reduce((schema, input) => {
		const { id, required } = input;
		if (id !== 'company') {
			schema[id] = Yup.string().nullable()
				.when('company', {
					is: true,
					then: required ? Yup.string().nullable().required(tr('Required')) : Yup.string().nullable(),
				});
		}
		return schema;
	}, {});

	const mergedSchema = {
		...personSchemaObject,
		...companySchemaObject,
		acceptsTermsConditions: Yup.boolean().oneOf([true], tr('Required')),
	};

	return Yup.object().shape(mergedSchema);
};

export default checkoutSchema;

